var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M15.4,28.2a1.9,1.9,0,0,0,3,.2L22,24.8V36a2,2,0,0,0,4,0V24.8l3.6,3.6a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7l-7-6.9a1.9,1.9,0,0,0-2.8,0l-7,6.9A2.1,2.1,0,0,0,15.4,28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808080",
    d: "M40.5,21.8a9.1,9.1,0,0,0-3.4-6.5A9.8,9.8,0,0,0,29.6,13,12.3,12.3,0,0,0,19.4,7a11.6,11.6,0,0,0-8.8,4,12.4,12.4,0,0,0-3.2,8.4,11.8,11.8,0,0,0-5.2,8.2A11.5,11.5,0,0,0,5.3,37.8,12.4,12.4,0,0,0,14,41h2a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H14a7.9,7.9,0,0,1-5.9-2.1,7.6,7.6,0,0,1-2-6.7,7.3,7.3,0,0,1,1.5-3.5,8.1,8.1,0,0,1,2.7-2.5,1.8,1.8,0,0,0,1.1-1.9h0a9.1,9.1,0,0,1,2.2-6.6A7.7,7.7,0,0,1,19.4,11a7.3,7.3,0,0,1,4.5,1.6A8.8,8.8,0,0,1,26.7,16a2,2,0,0,0,1.8,1.2H29a6.5,6.5,0,0,1,5.7,1.3,6,6,0,0,1,1.8,4.4v.4a1.6,1.6,0,0,0,1.2,1.7h.2A6.2,6.2,0,0,1,42,31c0,.6-.4,6-7.5,6H32a2,2,0,0,0-2,2h0a2,2,0,0,0,2,2h2.5c7.7,0,11.3-5.1,11.5-9.9A9.9,9.9,0,0,0,40.5,21.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.5aee642fd23ac2b49135b403421f25ba.svg";
export { ForwardRef as ReactComponent };